<main class="catalog" id="catalog">
  <ng-container *ngIf="!loading">
<a class="project hvr-sweep-to-right" *ngFor="let project of projects" routerLink="/project/{{project.id}}" (mouseover)="moveStrip($event)" (mouseout)="resetStrip($event)">
    <div class="imgHolder" [style.backgroundImage]="'url('+project.previewMob+')'"></div>
  </a>
  </ng-container>
</main>